(function ($) {
    $(document).ready(function () {
        pressAwardsCarousel();
    });

    function pressAwardsCarousel() {
        var wraps = $('.section.press_awards.layout_carousel');
        wraps.each(function () {
            var wrap = $(this).find('.slider_inner_wrap');
            if (wrap.length > 0) {
                var countEl = wrap.find('.article_wrap').length;
                var slidesToShow = 3;
                var window_width = $(window).width();
                var hasCarousel = false;

                if(window_width < 500){
                    if(countEl > 1){
                        hasCarousel = true;
                    }
                } else if(window_width < 769){
                    if(countEl > 2){
                        hasCarousel = true;
                    }
                } else if(window_width < 1501){
                    if(countEl > 3){
                        hasCarousel = true;
                    }
                } else {
                    if(countEl > 4 ){
                        hasCarousel = true;
                    }
                }

                wrap.on("init", function () {
                    lazyLoadInstance.update();
                });

                if(hasCarousel){
                    wrap.slick({
                        autoplay: false,
                        arrows: false,
                        dots: countEl > slidesToShow,
                        infinite: true,
                        appendDots: wrap.closest('.section').find('.pager'),
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        variableWidth: false,
                        centerMode: false,
                        rtl: $('html').attr('dir') === 'rtl',
                        responsive: [
                            {
                                breakpoint: 769,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 500,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    adaptiveHeight: true
                                }
                            },
                        ]
                    });
                }

            }
        });
    }
})(jQuery);